(() => {
  const initialize = (root) => {
    if (root.dataset.apPdReady === 'true') return;
    root.dataset.apPdReady = 'true';
    const rail = root.querySelector('[data-ap-pd-rail]');
    const cards = [...root.querySelectorAll('[data-ap-pd-card]')];
    const filters = [...root.querySelectorAll('[data-ap-pd-filter]')];
    const previous = root.querySelector('[data-ap-pd-prev]');
    const next = root.querySelector('[data-ap-pd-next]');
    const status = root.querySelector('[data-ap-pd-status]');
    const count = root.querySelector('[data-ap-pd-visible-count]');
    if (!rail || !cards.length) return;
    const visibleCards = () => cards.filter((card) => !card.hidden);
    const updateNavigation = () => {
      if (!previous || !next) return;
      previous.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
    };
    const move = (direction) => {
      const card = visibleCards()[0];
      if (!card) return;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };
    const applyFilter = (button) => {
      const filter = button.dataset.apPdFilter;
      filters.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      cards.forEach((card) => { card.hidden = filter !== 'all' && !card.dataset.apPdFilters.split(/\s+/).includes(filter); });
      rail.scrollLeft = 0;
      const visible = visibleCards().length;
      if (count) count.textContent = visible;
      if (status) status.textContent = `${visible} ${visible === 1 ? 'product' : 'products'} shown`;
      requestAnimationFrame(updateNavigation);
    };
    filters.forEach((button) => button.addEventListener('click', () => applyFilter(button)));
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', updateNavigation, { passive: true });
    window.addEventListener('resize', updateNavigation);
    if (filters.length) applyFilter(filters.find((button) => button.classList.contains('is-active')) || filters[0]);
    else {
      const visible = visibleCards().length;
      if (count) count.textContent = visible;
      if (status) status.textContent = `${visible} ${visible === 1 ? 'product' : 'products'} shown`;
      updateNavigation();
    }
  };
  const initializeAll = () => document.querySelectorAll('[data-ap-product-discovery]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
